import type { Field, SitecoreBlockProps } from 'models/sitecore';

interface Props extends SitecoreBlockProps {
	fields?: {
		triggerbeeCampaignId?: Field<string>;
	};
}

export default function TriggerbeeCampaign({ fields }: Props) {
	const id = fields?.triggerbeeCampaignId?.value;
	if (!id) {
		return null;
	}
	return <div id={id} />;
}
TriggerbeeCampaign.displayName = 'TriggerbeeCampaign';
